import { generateNgrxServiceClient } from '@essent/ngrx-service-wrapper';
import { consumerClient } from '@integration/api-client/consumer';

export const { actions, effects } = generateNgrxServiceClient(
  'Consumer',
  consumerClient
);

export { actions as consumerActions, effects as consumerEffects };
